import type { SegmentInstance } from '../level/segments/SegmentInstance';

export const BusPhase = {
  /** Idling in its lane in SEG_BUS_START_40M – the runner gets in on contact. */
  Waiting: 'WAITING',
  /** The runner drives it. */
  Driving: 'DRIVING',
  /** The runner is out (end of the ride, load gone, missed): it brakes to a stop. */
  Done: 'DONE',
} as const;
export type BusPhase = (typeof BusPhase)[keyof typeof BusPhase];

/** Track-space pose of the van (origin = ground centre between the axles) – the presenter interpolates it. */
export interface BusPose {
  /** Track distance of the origin. */
  distance: number;
  /** Lateral position and height of the origin (height: the road or, in the air, above it). */
  x: number;
  y: number;
  /** Forward speed (m/s) and meters driven (the wheels turn with it). */
  speed: number;
  travelled: number;
  /** Airborne after a ramp. */
  airborne: boolean;
}

/** One ructec-Bulli ride (gameplay state only, no Babylon) – the BusManager runs it, the BusPresenter shows it. */
export class BusRide {
  phase: BusPhase = BusPhase.Waiting;
  /** Pieces of load still on the roof (CargoConfig.pieces at the start; 0 ends the ride). */
  cargo: number;
  /** Seat distance where the runner got in – the ride is measured from here. */
  startDistance = 0;
  /** Vertical speed while airborne, climb rate on the ground (m/s). */
  vy = 0;
  /** Braking once the runner is out (m/s²). */
  deceleration = 0;
  readonly pose: BusPose;
  readonly previous: BusPose;

  constructor(
    readonly segment: SegmentInstance,
    /** Lane it waits in. */
    readonly lane: number,
    start: { readonly distance: number; readonly x: number; readonly y: number },
    cargo: number,
  ) {
    this.cargo = cargo;
    this.pose = { ...start, speed: 0, travelled: 0, airborne: false };
    this.previous = { ...this.pose };
  }

  keepPrevious(): void {
    Object.assign(this.previous, this.pose);
  }
}
